import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const COURSES_CHANGE_STATUS_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
